import * as types from 'constants/ActionTypes';
import { Map } from 'immutable';

/**
 * The Gontijo client session as the rest of the funnel sees it.
 *
 * `isHydrated` matters more than it looks: until storage has been read, "no token" and "no token
 * yet" are the same value, and a gate that cannot tell them apart flashes a login prompt at a buyer
 * who is already signed in. Everything that gates on the session waits for this.
 */
const defaultState = Map({
  token: null,
  expiresAt: null,
  issuedAt: null,
  email: null,
  isHydrated: false,
  isValidating: false,
});

/**
 * Reducer for the Gontijo client session
 * @param {Object} state - Current state
 * @param {Object} action - Action to process
 * @returns {Object} New state
 */
export default function gontijoSession(state = defaultState, action) {
  switch (action.type) {
    case types.SET_GONTIJO_SESSION:
      return state.merge({
        token: action.record.token,
        expiresAt: action.record.expiresAt,
        issuedAt: action.record.issuedAt,
        email: action.record.email || null,
        isHydrated: true,
        isValidating: false,
      });
    case types.CLEAR_GONTIJO_SESSION:
      return state.merge({
        token: null,
        expiresAt: null,
        issuedAt: null,
        email: null,
        isHydrated: true,
        isValidating: false,
      });
    case types.SET_GONTIJO_SESSION_VALIDATING:
      return state.set('isValidating', action.isValidating);
    case types.SET_GONTIJO_SESSION_HYDRATED:
      return state.set('isHydrated', true);
    default:
      return state;
  }
}
